<template>
  <div class="physical-home-wrapper my-0 relative z-10">
    
    <!-- 1. Compact Trade-In & Hardware Hero Banner -->
    <div class="buyback-hero-card relative rounded-2xl p-4 sm:p-5 mb-0 overflow-hidden bg-slate-950 border border-blue-500/20 shadow-lg text-white">
      <!-- Glow Blur -->
      <div class="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-blue-600/20 blur-3xl pointer-events-none"></div>

      <div class="relative z-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="space-y-2 text-center md:text-left">
          <div class="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-blue-500/10 border border-blue-400/30 text-blue-400 text-[11px] font-bold uppercase tracking-wider">
            <span>🔥 Store Buyback & Hardware Store</span>
          </div>

          <h3 class="text-xl sm:text-2xl font-extrabold tracking-tight text-white">
            Sell Laptops & Consoles for <span class="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-indigo-300 to-cyan-300">Instant Cash</span>
          </h3>

          <p class="text-slate-300 text-xs sm:text-sm max-w-xl">
            Get direct cash quotes & live chat negotiation when selling your tech to store admin!
          </p>
        </div>

        <div class="flex flex-wrap items-center gap-2 flex-shrink-0">
          <router-link 
            to="/buyback/sell" 
            class="px-4 py-2.5 rounded-xl font-bold text-xs text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 shadow-md shadow-blue-500/20 transition-all flex items-center gap-1.5"
          >
            <span>💰</span>
            <span>Sell Tech for Cash</span>
          </router-link>

          <router-link 
            to="/physical-catalog" 
            class="px-4 py-2.5 rounded-xl font-bold text-xs text-slate-200 bg-slate-900 border border-slate-700/80 hover:bg-slate-800 transition-all flex items-center gap-1.5"
          >
            <span>💻</span>
            <span>Hardware Catalog</span>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
// Component only displays the hero banner link to trade-in and hardware catalog
</script>
